/**
 * @generated SignedSource<<8332862ab398029836492159f1f5fa5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FindAccountAuthMethodsInput = {
  domain: string;
};
export type authFindAccountAuthMethodsQuery$variables = {
  input: FindAccountAuthMethodsInput;
};
export type authFindAccountAuthMethodsQuery$data = {
  readonly findAccountAuthMethods: {
    readonly accountName: string;
    readonly methods: ReadonlyArray<{
      readonly authorizationURL: string;
      readonly name: string;
    } | null>;
    readonly preferredType: string;
  };
};
export type authFindAccountAuthMethodsQuery = {
  response: authFindAccountAuthMethodsQuery$data;
  variables: authFindAccountAuthMethodsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FindAccountAuthMethodsPayload",
    "kind": "LinkedField",
    "name": "findAccountAuthMethods",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "preferredType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthMethod",
        "kind": "LinkedField",
        "name": "methods",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "authorizationURL",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "authFindAccountAuthMethodsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "authFindAccountAuthMethodsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4477142ab1d89f8227bf3b0c7bee9850",
    "id": null,
    "metadata": {},
    "name": "authFindAccountAuthMethodsQuery",
    "operationKind": "query",
    "text": "query authFindAccountAuthMethodsQuery(\n  $input: FindAccountAuthMethodsInput!\n) {\n  findAccountAuthMethods(input: $input) {\n    accountName\n    preferredType\n    methods {\n      name\n      authorizationURL\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1196ad2e03285a8a3eca1b3c6d0b012f";

export default node;
